export enum TemplateTypes {
  REST = 'REST',
  SOAP = 'SOAP',
}
